export default __webpack_public_path__ + "static/media/Use-Cases-Section-Collaboration.a53e7e52.jpg";